export const YEAR_MIN_VALUE = 1900;
